import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/monte-carlo-retirement',
  component: () => import('../../routes/MonteCarloRetirement.svelte'),
  card: {
    id: 'monte-carlo-retirement',
    title: 'Monte Carlo Retirement',
    description: 'Simulate thousands of retirement scenarios to find the probability your portfolio lasts. Accounts for market volatility, inflation, and withdrawal rates.',
    icon: 'analytics',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/monte-carlo-retirement',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Monte Carlo Retirement Calculator – Probability-Based Retirement Planning',
    description: 'Free Monte Carlo retirement simulator runs 10,000 scenarios to calculate the probability your portfolio will last through retirement. Includes inflation-adjusted withdrawals and market volatility modeling.',
  },
};

export default meta;
